import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=0030a4a7&scoped=true&"
var script = {}
import style0 from "../../assets/scss/footer.scss?vue&type=style&index=0&id=0030a4a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0030a4a7",
  null
  
)

export default component.exports